const prostaffCategoryPage = {
  key: 'prostaffCategoryPage',
  name: 'Prostaff Category Page',
  sportdogProStaffAlt: 'SportDOG ProStaff',
};

module.exports = {
  prostaffCategoryPage,
};
